import React from 'react';
import PropTypes from 'prop-types';
import RestrictedEmails from './restrictedEmails';
import ErrorDisplay from '../shared/errorDisplay';

const DuplicateEmails = props => {
  let duplicateEmails = [];

  if (props.duplicateEmails) {
    duplicateEmails = props.duplicateEmails.emails.map(email => (
      /* eslint-disable jsx-a11y/anchor-is-valid */
      <li key={email}>
        <a>{email}</a>
      </li>
      /* eslint-enable jsx-a11y/anchor-is-valid */
    ));
  }

  return (
    <div>
      <h3>{props.translations['found-duplicates']}</h3>
      <p>{props.translations['people-already-invited']}</p>
      <div className="duplicates">
        <ul>{duplicateEmails}</ul>
      </div>
      {props.error === 'network-duplicates' && (
        <ErrorDisplay errorMessage="There was an error sending your invites. Please try again." />
      )}
      <div className="two-button-area">
        <button
          onClick={() => props.resendDuplicates(props.duplicateEmails)}
          className="secondary-action"
        >
          {props.translations['resend-invitation']}
        </button>
        <button
          onClick={() =>
            props.removeDuplicates(props.duplicateEmails.delayDisplayAlert)
          }
          style={{ backgroundColor: props.color, borderColor: props.color }}
        >
          {props.translations['remove-duplicates']}
        </button>
      </div>
      {props.restrictedEmails &&
        props.restrictedEmails.length > 0 && (
          <RestrictedEmails
            translations={props.translations}
            color={props.color}
            restrictedEmails={props.restrictedEmails}
            duplicateEmailsExist
          />
        )}
    </div>
  );
};

DuplicateEmails.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  removeDuplicates: PropTypes.func.isRequired,
  resendDuplicates: PropTypes.func.isRequired,
  duplicateEmails: PropTypes.shape({
    emails: PropTypes.array.isRequired,
    resendUrl: PropTypes.string.isRequired,
    delayDisplayAlert: PropTypes.bool.isRequired,
  }).isRequired,
  error: PropTypes.string,
  restrictedEmails: PropTypes.array,
};

DuplicateEmails.defaultProps = {
  error: '',
  restrictedEmails: [],
};

export default DuplicateEmails;
